import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface VideoInfo {
  isReady: boolean;
  hlsUrl?: string;
  duration?: number;
  status?: string;
}

export interface VideoResponse {
  success: boolean;
  data: VideoInfo;
}

export interface PlaybackResponse {
  hlsUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  private apiUrl = environment.apiUrl + '/lesson-video';

  constructor(private http: HttpClient) { }

  /**
   * Busca informações do vídeo da lição
   * @param lessonId ID da lição
   */
  getVideoInfo(lessonId: string): Observable<VideoResponse> {
    return this.http.get<VideoResponse>(`${this.apiUrl}/video/${lessonId}`);
  }

  /**
   * Busca URL de playback do vídeo
   * @param lessonId ID da lição
   */
  getPlaybackUrl(lessonId: string): Observable<PlaybackResponse> {
    return this.http.get<PlaybackResponse>(`${this.apiUrl}/${lessonId}/play`);
  }
}